import React from 'react';
import { Star } from 'lucide-react';
import { REVIEWS } from '../data/content';
import './ReviewsSection.css';

export default function ReviewsSection() {
  return (
    <section className="section reviews-section" id="reviews">
      <div className="sec-in">
        <div className="eyebrow">Reviews</div>
        <div className="sec-title">What homeowners are saying</div>
        <div className="sec-sub">Over 50,000 five-star reviews from homeowners across the USA.</div>

        <div className="rev-grid">
          {REVIEWS.map((r) => (
            <div key={r.name} className="rev-card">
              <div className="stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    size={15}
                    strokeWidth={1.5}
                    fill={i < r.stars ? '#f59e0b' : 'none'}
                    color={i < r.stars ? '#f59e0b' : '#d1d5db'}
                  />
                ))}
              </div>
              <p className="rev-text">{r.text}</p>
              <div className="rev-auth">
                <div
                  className="rev-av"
                  style={{ background: r.bg, color: r.color }}
                >
                  {r.initials}
                </div>
                <div>
                  <div className="rev-name">{r.name}</div>
                  <div className="rev-meta">{r.meta}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
